// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .topSection {
  height: 40%;
  padding: 1rem;
}

.bottomSection {
  height: 50%;
}

.chartWrapper {
  min-height: 50px;

} */
/* TAB HEADER */
.Pdl_tabHeader__HrgRT {
  height: 38px;
  display: flex;
  align-items: center;
  margin-top: 12px;
}

/* TAB BUTTONS */
.Pdl_tabBtn__bBGRi {
  background: none;
  border: none;
  font-weight: 600;
  color: #6c757d;
  padding-bottom: 8px;
  cursor: pointer;
}

.Pdl_activeTab__9pWQL {
  color: #0d6efd;
  border-bottom: 2px solid #0d6efd;
}

/* CONTENT SECTION UNDER TABS */
.Pdl_contentWrapper__BWJsG {
  padding-top: 4px;
}

/* KPI FIX — PREVENT HEIGHT GROWTH */
.Pdl_kpiCard__cPPQg {
  height: 90px;          /* 🔑 fixed height */
  /* display: flex; */
  /* align-items: center; */
  /* justify-content: center; */
  border-radius: 8px;
  
}

/* GRAPH SHOULD FEEL ATTACHED TO TAB CONTENT */
.Pdl_graphWrapper__Ed3Pl {
  margin-top: 12px;
  background: #ffffff;
  border-radius: 8px;
  padding: 12px;
}

.Pdl_projectLink__pNPmG {
  font-size: 13px;
  font-weight: 600;
  color: #555;
  cursor: pointer;
}

.Pdl_projectLink__pNPmG:hover {
  color: #000;
  border-bottom: 2px solid #000;
}

.Pdl_header__jVVel {
  position: sticky;
  top: 0;
  z-index: 1000;
  background-color: white;
}


.Pdl_projectPillWrapper__WFCtV {
  display: flex;
  align-items: center;
  gap: 10px;
  position: relative;
}

.Pdl_projectPill__WpUAF {
  padding: 6px 16px;
  border-radius: 18px;
  background: #ffffff;
  border: 1px solid #e2e6ea;
  font-size: 13px;
  font-weight: 600;
  color: #495057;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
}

.Pdl_projectPill__WpUAF:hover {
  background: #4e79a7;
  transform: translateY(-1px);
}

.Pdl_active__-PPO5 {
  background: #212529;
  color: #ffffff;
  border-color: #212529;
}

/* hidden pills container */
.Pdl_hiddenPills__psV3A {
  display: flex;
  gap: 10px;
  opacity: 0;
  transform: translateX(-10px);
  pointer-events: none;
  transition: all 0.25s ease;
}

/* reveal on hover */
.Pdl_projectPillWrapper__WFCtV:hover .Pdl_hiddenPills__psV3A {
  opacity: 1;
  transform: translateX(0);
  pointer-events: auto;
}

.Pdl_kpiTitle__znc4b {
  position: absolute;
  top: 2px;
  left: 6px;
  font-size: 12px;
  color: #9aa0a6;
  font-weight: 500;
  
}

.Pdl_kpiValue__Sf5r- {
  font-size: 20px;
  font-weight: 700;
  color: #1f2937;
  line-height: 1.2;
}

.Pdl_kpiTrend__SqncX {
  font-size: 12px;
  margin-top: 2px;
}

.Pdl_kpiUp__pnjQO {
  color: #16a34a; /* green */
  font-weight: 600;
}

.Pdl_kpiSize__nBp2u {
  color: #9ca3af; /* light grey */
}
.Pdl_kpiValue2__KmmCB {
  font-size: 10px;
  font-weight: 400;
  color: #1f2937;
  line-height: 1.2;
}

.Pdl_popupOverlay__E-3Zq {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.Pdl_popupContent__DEL-E {
  position: relative;  /* important! button will be relative to this */
  background: white;
  padding: 40px 20px 20px 20px; /* extra top padding for button space */
  border-radius: 8px;
  max-width: 800px;
  width: 90%;
  box-shadow: 0 5px 20px rgba(0,0,0,0.3);
}

.Pdl_closeBtn__hEAWE {
  position: absolute;
  top: 10px;      /* distance from top edge of popupContent */
  right: 10px;    /* distance from right edge of popupContent */
  background: transparent;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #333;
}

/* .kpiIcon {
  z-index: 10;
} */

/* .kpiIcon {
  position: absolute;   
  top: 10px;            
  right: 10px;          
  z-index: 10;
} */

.Pdl_kpiIcon__HMMFP button {
  pointer-events: auto;
}

.Pdl_kpiUp__pnjQO {
  color: #28a745; /* green */
}

.Pdl_kpiDown__8v3TR {
  color: #dc3545; /* red */
}

/* BotButton.module.css */
.Pdl_botButton__Fu253 {
  cursor: pointer;
  background-color: #6366f1; 
  color: rgb(50, 18, 18);
  padding: 6px 8px;
  border-radius: 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
   position: fixed; /* use fixed instead of sticky */
   top: 55px;       /* distance from top */
   right: 20px;     /* distance from right */
   z-index: 9999;   /* make sure it’s above other elements */
  /* Animation */
  opacity: 0;
  transform: translateY(20px) scale(0.95);
  animation: Pdl_fadeInUp__g9moF 0.8s ease forwards;
}

@keyframes Pdl_fadeInUp__g9moF {
  0% {
    opacity: 0;
    transform: translateY(20px) scale(0.95);
  }
  100% {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}`, "",{"version":3,"sources":["webpack://./src/componets/Dashboard_Summary/Components/Pdl.module.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;GAYG;AACH,eAAe;AACf;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gCAAgC;AAClC;;AAEA,+BAA+B;AAC/B;EACE,gBAAgB;AAClB;;AAEA,oCAAoC;AACpC;EACE,YAAY,WAAW,oBAAoB;EAC3C,mBAAmB;EACnB,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;;AAEpB;;AAEA,8CAA8C;AAC9C;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,aAAa;EACb,uBAAuB;AACzB;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,SAAS;EACT,UAAU;EACV,4BAA4B;EAC5B,oBAAoB;EACpB,0BAA0B;AAC5B;;AAEA,oBAAoB;AACpB;EACE,UAAU;EACV,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,eAAe;EACf,cAAc;EACd,gBAAgB;;AAElB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,cAAc,EAAE,UAAU;EAC1B,gBAAgB;AAClB;;AAEA;EACE,cAAc,EAAE,eAAe;AACjC;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,kBAAkB,GAAG,+CAA+C;EACpE,iBAAiB;EACjB,4BAA4B,EAAE,uCAAuC;EACrE,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,SAAS,OAAO,2CAA2C;EAC3D,WAAW,KAAK,6CAA6C;EAC7D,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;AACb;;AAEA;;GAEG;;AAEH;;;;;GAKG;;AAEH;EACE,oBAAoB;AACtB;;AAEA;EACE,cAAc,EAAE,UAAU;AAC5B;;AAEA;EACE,cAAc,EAAE,QAAQ;AAC1B;;AAEA,yBAAyB;AACzB;EACE,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,uCAAuC;GACtC,eAAe,EAAE,gCAAgC;GACjD,SAAS,QAAQ,sBAAsB;GACvC,WAAW,MAAM,wBAAwB;GACzC,aAAa,IAAI,wCAAwC;EAC1D,cAAc;EACd,UAAU;EACV,uCAAuC;EACvC,iDAAsC;AACxC;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF","sourcesContent":["/* .topSection {\n  height: 40%;\n  padding: 1rem;\n}\n\n.bottomSection {\n  height: 50%;\n}\n\n.chartWrapper {\n  min-height: 50px;\n\n} */\n/* TAB HEADER */\n.tabHeader {\n  height: 38px;\n  display: flex;\n  align-items: center;\n  margin-top: 12px;\n}\n\n/* TAB BUTTONS */\n.tabBtn {\n  background: none;\n  border: none;\n  font-weight: 600;\n  color: #6c757d;\n  padding-bottom: 8px;\n  cursor: pointer;\n}\n\n.activeTab {\n  color: #0d6efd;\n  border-bottom: 2px solid #0d6efd;\n}\n\n/* CONTENT SECTION UNDER TABS */\n.contentWrapper {\n  padding-top: 4px;\n}\n\n/* KPI FIX — PREVENT HEIGHT GROWTH */\n.kpiCard {\n  height: 90px;          /* 🔑 fixed height */\n  /* display: flex; */\n  /* align-items: center; */\n  /* justify-content: center; */\n  border-radius: 8px;\n  \n}\n\n/* GRAPH SHOULD FEEL ATTACHED TO TAB CONTENT */\n.graphWrapper {\n  margin-top: 12px;\n  background: #ffffff;\n  border-radius: 8px;\n  padding: 12px;\n}\n\n.projectLink {\n  font-size: 13px;\n  font-weight: 600;\n  color: #555;\n  cursor: pointer;\n}\n\n.projectLink:hover {\n  color: #000;\n  border-bottom: 2px solid #000;\n}\n\n.header {\n  position: sticky;\n  top: 0;\n  z-index: 1000;\n  background-color: white;\n}\n\n\n.projectPillWrapper {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  position: relative;\n}\n\n.projectPill {\n  padding: 6px 16px;\n  border-radius: 18px;\n  background: #ffffff;\n  border: 1px solid #e2e6ea;\n  font-size: 13px;\n  font-weight: 600;\n  color: #495057;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  white-space: nowrap;\n}\n\n.projectPill:hover {\n  background: #4e79a7;\n  transform: translateY(-1px);\n}\n\n.active {\n  background: #212529;\n  color: #ffffff;\n  border-color: #212529;\n}\n\n/* hidden pills container */\n.hiddenPills {\n  display: flex;\n  gap: 10px;\n  opacity: 0;\n  transform: translateX(-10px);\n  pointer-events: none;\n  transition: all 0.25s ease;\n}\n\n/* reveal on hover */\n.projectPillWrapper:hover .hiddenPills {\n  opacity: 1;\n  transform: translateX(0);\n  pointer-events: auto;\n}\n\n.kpiTitle {\n  position: absolute;\n  top: 2px;\n  left: 6px;\n  font-size: 12px;\n  color: #9aa0a6;\n  font-weight: 500;\n  \n}\n\n.kpiValue {\n  font-size: 20px;\n  font-weight: 700;\n  color: #1f2937;\n  line-height: 1.2;\n}\n\n.kpiTrend {\n  font-size: 12px;\n  margin-top: 2px;\n}\n\n.kpiUp {\n  color: #16a34a; /* green */\n  font-weight: 600;\n}\n\n.kpiSize {\n  color: #9ca3af; /* light grey */\n}\n.kpiValue2 {\n  font-size: 10px;\n  font-weight: 400;\n  color: #1f2937;\n  line-height: 1.2;\n}\n\n.popupOverlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0,0,0,0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 9999;\n}\n\n.popupContent {\n  position: relative;  /* important! button will be relative to this */\n  background: white;\n  padding: 40px 20px 20px 20px; /* extra top padding for button space */\n  border-radius: 8px;\n  max-width: 800px;\n  width: 90%;\n  box-shadow: 0 5px 20px rgba(0,0,0,0.3);\n}\n\n.closeBtn {\n  position: absolute;\n  top: 10px;      /* distance from top edge of popupContent */\n  right: 10px;    /* distance from right edge of popupContent */\n  background: transparent;\n  border: none;\n  font-size: 24px;\n  cursor: pointer;\n  color: #333;\n}\n\n/* .kpiIcon {\n  z-index: 10;\n} */\n\n/* .kpiIcon {\n  position: absolute;   \n  top: 10px;            \n  right: 10px;          \n  z-index: 10;\n} */\n\n.kpiIcon button {\n  pointer-events: auto;\n}\n\n.kpiUp {\n  color: #28a745; /* green */\n}\n\n.kpiDown {\n  color: #dc3545; /* red */\n}\n\n/* BotButton.module.css */\n.botButton {\n  cursor: pointer;\n  background-color: #6366f1; \n  color: rgb(50, 18, 18);\n  padding: 6px 8px;\n  border-radius: 12px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 700;\n  box-shadow: 0 4px 12px rgba(0,0,0,0.15);\n   position: fixed; /* use fixed instead of sticky */\n   top: 55px;       /* distance from top */\n   right: 20px;     /* distance from right */\n   z-index: 9999;   /* make sure it’s above other elements */\n  /* Animation */\n  opacity: 0;\n  transform: translateY(20px) scale(0.95);\n  animation: fadeInUp 0.8s ease forwards;\n}\n\n@keyframes fadeInUp {\n  0% {\n    opacity: 0;\n    transform: translateY(20px) scale(0.95);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tabHeader": `Pdl_tabHeader__HrgRT`,
	"tabBtn": `Pdl_tabBtn__bBGRi`,
	"activeTab": `Pdl_activeTab__9pWQL`,
	"contentWrapper": `Pdl_contentWrapper__BWJsG`,
	"kpiCard": `Pdl_kpiCard__cPPQg`,
	"graphWrapper": `Pdl_graphWrapper__Ed3Pl`,
	"projectLink": `Pdl_projectLink__pNPmG`,
	"header": `Pdl_header__jVVel`,
	"projectPillWrapper": `Pdl_projectPillWrapper__WFCtV`,
	"projectPill": `Pdl_projectPill__WpUAF`,
	"active": `Pdl_active__-PPO5`,
	"hiddenPills": `Pdl_hiddenPills__psV3A`,
	"kpiTitle": `Pdl_kpiTitle__znc4b`,
	"kpiValue": `Pdl_kpiValue__Sf5r-`,
	"kpiTrend": `Pdl_kpiTrend__SqncX`,
	"kpiUp": `Pdl_kpiUp__pnjQO`,
	"kpiSize": `Pdl_kpiSize__nBp2u`,
	"kpiValue2": `Pdl_kpiValue2__KmmCB`,
	"popupOverlay": `Pdl_popupOverlay__E-3Zq`,
	"popupContent": `Pdl_popupContent__DEL-E`,
	"closeBtn": `Pdl_closeBtn__hEAWE`,
	"kpiIcon": `Pdl_kpiIcon__HMMFP`,
	"kpiDown": `Pdl_kpiDown__8v3TR`,
	"botButton": `Pdl_botButton__Fu253`,
	"fadeInUp": `Pdl_fadeInUp__g9moF`
};
export default ___CSS_LOADER_EXPORT___;
